export default {
  filterData : {
    Products: {
      label: 'Products',
      allFilterLabel: "All Products",
      items: [
        { name: "Citrix Analytics for Performance", id: "citrix_analytics_for_performance" },
        { name: "Citrix Analytics for Security", id: "citrix_analytics_for_security" },
        { name: "Citrix DaaS (formerly Citrix Virtual Apps and Desktops service)", id: "citrix_virtual_apps_and_desktops" },
        {
          name: "Citrix DaaS Standard for Azure",
          id: "citrix_virtual_apps_and_desktops_standard_for_azure"
        },
        {
          name: "Citrix DaaS Standard for Google Cloud",
          id: "citrix_daas_standard_for_google_cloud",
        },
        { name: "Citrix Endpoint Management", id: "citrix_endpoint_management" },
        { name: "Citrix Secure Private Access", id: "citrix_secure_private_access" },
        { name: "Citrix Virtual Apps and Desktops", id: "citrix_virtual_apps_desktops" },
        { name: "Citrix Workspace", id: "citrix_workspace" },
      ],
    },
    Topics: {
      label: "Topics",
      allFilterLabel: "All Topics",
      items: [
        { name: "Access management", id: "Access management" },
        { name: "Analytics and monitoring", id: "Analytics and monitoring" },
        { name: "Application and security", id: "Application delivery and security" },
        { name: "Citrix and Google", id: "Citrix and Google" },
        { name: "Citrix and Microsoft", id: "Citrix and Microsoft" },
        { name: "Cloud migration", id: "Cloud migration" },
        { name: "Compare", id: "Compare" },
        { name: "Digital workspaces", id: "Digital workspaces" },
        { name: "Employee experience", id: "Employee experience" },
        { name: "Hybrid cloud", id: "Hybrid cloud" },
        { name: "Hybrid work", id: "Hybrid work" },
        { name: "Manage and optimize", id: "Manage and optimize" },
        { name: "Microservices and devOps", id: "Microservices and devOps" },
        { name: "Onboarding and adoption", id: "Onboarding and adoption" },
        { name: "Partner integrations", id: "Partner integrations" },
        { name: "Product overview", id: "Product overview" },
        { name: "Security and compliance", id: "Security and compliance" },
        { name: "Small business", id: "Small business" },
        { name: "Specifications", id: "Specifications" },
        { name: "Sustainability", id: "Sustainability" },
        { name: "Unified endpoint management", id: "Unified endpoint management" },
        { name: "VDI and DaaS", id: "VDI and DaaS" },
      ],
    },   
    Type: {
      label: 'Type',
      allFilterLabel: "All Types",
      items: [
        { name: "Analyst report", id: "Analyst report" },
        { name: "Assessment tool", id: "Assessment tool" },
        { name: "Customer story", id: "Customer story" },
        { name: "Data sheet", id: "Data sheet" },
        { name: "Demo", id: "Demo" },
        { name: "e-book", id: "e-book" },
        { name: "Guide", id: "Guide" },
        { name: "Infographic", id: "Infographic" },
        { name: "Interactive tour", id: "Interactive tour" },
        { name: "Podcast", id: "Podcast" },
        { name: "Resource kit", id: "Resource kit" },
        { name: "Solution brief", id: "Solution brief" },
        { name: "Technical brief", id: "Technical brief" },
        { name: "Video", id: "Video" },
        { name: "Webinar", id: "Webinar" },
        { name: "White paper", id: "White paper" },
      ],
    },
    Industry: {
      label: "Industry",
      allFilterLabel: "All Industries",
      items: [
        { name: "Education", id: "education" },
        { name: "Financial Services", id: "financial_service" },
        { name: "Government", id: "government" },
        { name: "Healthcare", id: "healthcare" },
        { name: "Manufacturing", id: "manufacturing" },
        { name: "Retail", id: "retail" }
      ],
    }
  },
    searchPlaceholder: "Search Library",
    titles : {
      label1: "Trending now",
      label2: "Newest resources",
      label3: "Recently viewed pages",
      label4: "Recommended resources"
    },
    showMoreLabel: "Show more",
    clearAllSelected: "Clear All Selected",
    searchResults: "Search results for",
    clearAllFilters: "Clear all filters",
    noResultsFound: "No assets meet your selected criteria",
    resetView: "Reset view",
    filterLabel: "Filter",
    filteredRes: "Filtered results",
    filterRes: "Filter your results",
    clearAllCta: "Clear all",
    applyCta: "Apply",
    view: "View",
    includeEnglishRes: "Include English resources"
  };
  
